var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDanger(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "danger",
    transform: "translate(-1.25 -1.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38055",
    "data-name": "Path 38055",
    d: "M16.358,17.679A2.679,2.679,0,1,1,13.679,15,2.679,2.679,0,0,1,16.358,17.679Z",
    transform: "translate(15.571 21.959)",
    fill: "#ff9d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38056",
    "data-name": "Path 38056",
    d: "M15.268,8.259a2.009,2.009,0,0,0-4.018,0V24.332a2.009,2.009,0,0,0,4.018,0Z",
    transform: "translate(15.991 7.825)",
    fill: "#ff9d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38057",
    "data-name": "Path 38057",
    d: "M29.25,1.25a28,28,0,1,0,28,28A28,28,0,0,0,29.25,1.25Zm-24.093,28A24.093,24.093,0,1,1,29.25,53.343,24.093,24.093,0,0,1,5.157,29.25Z",
    transform: "translate(0 0)",
    fill: "#ff9d00",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanger);
export default __webpack_public_path__ + "static/media/danger.2ffe679c.svg";
export { ForwardRef as ReactComponent };